import React from "react";
import { Link } from "react-router";
import { Routes } from "../../routes/routes";

export const Home = () => {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f172a, #020617)",
        minHeight: "100vh",
        color: "#ffffff",
        borderRadius: 20,
      }}
    >
      <section className="container py-5">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <h1 className="display-5 fw-bold mb-3">
              Fixer Aviation Management Panel
            </h1>
            <p className="fs-5 mb-4" style={{ color: "#c7d2fe" }}>
              Centralized control panel for aircraft listings, maintenance
              workflows, operational data and user management.
            </p>
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={Routes.DashboardIndex.path}
                className="btn btn-light btn-lg px-4 fw-semibold"
              >
                Open Dashboard
              </Link>
              <span style={{ color: "#94a3b8" }}>
                Aircraft • Operations • Analytics
              </span>
            </div>
          </div>

          <div className="col-lg-6 text-center">
            <img
              src="https://img.freepik.com/free-vector/professional-dashboard-user-panel_23-2148368370.jpg?semt=ais_hybrid&w=740&q=80"
              alt="Aircraft Cockpit"
              style={{
                maxWidth: "100%",
                borderRadius: 24,
                boxShadow: "0 30px 90px rgba(0,0,0,.55)",
                animation: "float 6s ease-in-out infinite",
              }}
            />
          </div>
        </div>
      </section>

      <section
        style={{ background: "#ffffff", color: "#020617", padding: "100px 0" }}
      >
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Control. Manage. Analyze.</h2>
            <p className="text-muted fs-5">
              Everything you need to manage aviation assets in one platform
            </p>
          </div>

          <div className="row g-5">
            {[
              {
                title: "Aircraft Management",
                img: "https://images.unsplash.com/photo-1544016768-982d1554f0b9?q=80&w=1400&auto=format&fit=crop",
                bg: "linear-gradient(135deg, #020617, #1e293b)",
                shadow: "rgba(15,23,42,.45)",
                items: [
                  "Aircraft listing & details",
                  "Images & documentation",
                  "Status & publish control",
                ],
              },
              {
                title: "Operations & Maintenance",
                img: "https://images.unsplash.com/photo-1544016768-982d1554f0b9?q=80&w=1400&auto=format&fit=crop",
                bg: "linear-gradient(135deg, #1e293b, #334155)",
                shadow: "rgba(30,41,59,.45)",
                items: [
                  "Maintenance tracking",
                  "Operational workflows",
                  "Approval & audit flows",
                ],
              },
              {
                title: "Analytics & Reporting",
                img: "https://images.unsplash.com/photo-1544016768-982d1554f0b9?q=80&w=1400&auto=format&fit=crop",
                bg: "linear-gradient(135deg, #0f172a, #020617)",
                shadow: "rgba(2,6,23,.55)",
                items: [
                  "Platform statistics",
                  "User activity insights",
                  "Operational KPIs",
                ],
              },
            ].map((x, i) => (
              <div key={i} className="col-md-4">
                <div
                  style={{
                    background: x.bg,
                    borderRadius: 28,
                    padding: 36,
                    height: "100%",
                    color: "#ffffff",
                    boxShadow: `0 30px 80px ${x.shadow}`,
                    transition: "all .45s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform =
                      "translateY(-12px) scale(1.04)";
                    e.currentTarget.style.boxShadow = `0 40px 120px ${x.shadow}`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.boxShadow = `0 30px 80px ${x.shadow}`;
                  }}
                >
                  <img
                    src={x.img}
                    alt={x.title}
                    style={{
                      width: "100%",
                      height: 160,
                      marginBottom: 24,
                      borderRadius: 18,
                      objectFit: "cover",
                      filter: "drop-shadow(0 14px 40px rgba(0,0,0,.45))",
                    }}
                  />
                  <h3 className="fw-bold mb-3">{x.title}</h3>
                  <ul style={{ paddingLeft: 18, opacity: 0.9 }}>
                    {x.items.map((t, k) => (
                      <li key={k}>{t}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ background: "#020617", color: "#e5e7eb" }}>
        <div className="container py-5">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <h3 className="fw-bold mb-3">Enterprise-Ready Architecture</h3>
              <p className="fs-6" style={{ color: "#cbd5f5" }}>
                Designed for scalable aviation operations with role-based
                access, audit logs and modular permissions.
              </p>
              <ul style={{ color: "#cbd5f5" }}>
                <li>Role & permission management</li>
                <li>Secure authentication</li>
                <li>Modular feature control</li>
                <li>Future-proof architecture</li>
              </ul>
            </div>

            <div className="col-lg-6 text-center">
              <img
                src="https://images.unsplash.com/photo-1474302770737-173ee21bab63?q=80&w=1800&auto=format&fit=crop"
                alt="Aircraft Infrastructure"
                style={{
                  maxWidth: "100%",
                  borderRadius: 24,
                  boxShadow: "0 25px 80px rgba(0,0,0,.45)",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <footer className="text-center py-4" style={{ color: "#94a3b8" }}>
        © {new Date().getFullYear()} Fixer Aviation. All rights reserved.
      </footer>

      <style>{`
        @keyframes float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-14px); }
          100% { transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};
